import React, { useState, useEffect } from 'react';
import Globals from '../Globals.js';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import { functions } from '../firebase';
import { httpsCallable } from 'firebase/functions';

const AllGlobals = Globals;

const DeletePendingPlayerRequest = ({ currentTask, setCurrentTask, teamName, actionRequestId, selectedPlayerName }) => {

    const [errorDeleting, setErrorDeleting] = useState(false);


    const deletePlayerRequest = async (e) => {
        e.preventDefault();
        setErrorDeleting(false);
        try {
            const deletePlayerRequest = httpsCallable(functions, 'deletePlayerRequest');
            const result = await deletePlayerRequest({ requestId: actionRequestId });
            
            console.log("Deleted successfully! Server response:", result.data);
            setCurrentTask(AllGlobals.taskNumbers.none);

            //refetch the pending requests list to reflect the deletion
            window.location.reload();
            
        } catch (error) {
            // Catch backend validation or authorization failures here
            console.error("Failed to delete request via backend:", error.message);
            setErrorDeleting(true);
        }
    }

    return (
        <Modal show={currentTask === AllGlobals.taskNumbers.deletePlayerRequest} onHide={() => setCurrentTask(AllGlobals.taskNumbers.none)}>
            <Form onSubmit={deletePlayerRequest}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Player Request</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label className="mb-3">Are you sure you want to delete the request for <b>{selectedPlayerName}</b>? This action cannot be undone.</Form.Label>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="danger" type='submit'>
                        Delete
                    </Button>
                    <Button variant="secondary" onClick={() => setCurrentTask(AllGlobals.taskNumbers.none)}>
                        Cancel
                    </Button>
                </Modal.Footer>                 
            </Form>
            <div className="toast-container position-fixed bottom-0 end-0 p-3">
                <Toast show={errorDeleting} onClose={() => setErrorDeleting(!errorDeleting)} delay={3000} autohide bg='danger'>
                    <Toast.Body>Player not deleted, please try again.</Toast.Body>
                </Toast>
            </div>
        </Modal>
    )
}

export default DeletePendingPlayerRequest;
